// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"264":"4008bdec","396":"ba013ffe","497":"f65afaa4","732":"d99f4a62","937":"2c4d1d01","992":"3f1d4f43"}[chunkId] + ".chunk.js";
};